// FacultyLogin.js
import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import "./FacultyLogin.css";

export default function FacultyLogin() {
  const { loginFaculty } = useAuth();
  const [facultyId, setFacultyId] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = () => {
    const faculties = JSON.parse(localStorage.getItem("faculties")) || [];

    // check match
    const found = faculties.find(
      (f) => f.id === facultyId && f.password === password
    );

    if (found) {
      loginFaculty(found); // save to AuthContext
      window.location.href = "/faculty-dashboard"; // navigate
    } else {
      alert("❌ Invalid Faculty ID or Password");
    }
  };

  return (
    <div className="login-container">
      <h2>👨‍🏫 Faculty Login</h2>
      <input
        placeholder="Faculty ID"
        value={facultyId}
        onChange={(e) => setFacultyId(e.target.value)}
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button onClick={handleLogin}>Login</button>
    </div>
  );
}

